module.exports = __webpack_public_path__ + "img/sma_home_bottom.2f1f9712.png";